import { useEffect } from 'react';
import confetti from 'canvas-confetti';

/** Brief user-triggered completion feedback, respecting reduced motion. */
export default function Celebration({ duration = 3000 }) {
  useEffect(() => {
    const end = Date.now() + duration;
    const interval = setInterval(() => {
      const remaining = end - Date.now();
      if (remaining <= 0) {
        clearInterval(interval);
        return;
      }
      const options = {
        startVelocity: 30,
        spread: 360,
        ticks: 60,
        zIndex: 0,
        disableForReducedMotion: true,
        particleCount: (50 * remaining) / duration,
      };
      confetti({ ...options, origin: { x: 0.1 + Math.random() * 0.2, y: Math.random() - 0.2 } });
      confetti({ ...options, origin: { x: 0.7 + Math.random() * 0.2, y: Math.random() - 0.2 } });
    }, 250);
    return () => clearInterval(interval);
  }, [duration]);
  return null;
}
